import { LookupType, VehicleClass } from 'app/utility/enums';
export class LookupModel
{
	public id?: string;
	public caption?: string;
	public parentId?: string;
	public collection?: string;
	public member?: number;
	public lookupType?: string;

	//transient fields
	public allowAddCode?: boolean;
	public codeCaption?: string;

	public allowAddReference?: boolean;
	public referenceCaption?: string;

	public allowAddCustomField1?: boolean;
	public customField1Caption?: string;
}

export class LookupInternalModel extends LookupModel
{
	public displayName: string;
	constructor()
	{
		super();
		this.lookupType = LookupType.Internal;
	}
}

export class LookupExternalModel extends LookupModel
{
	public lookupInternal: LookupInternalModel;
	public canAddNewValues: boolean;
	public code: string;
    public description: string;
	constructor()
	{
		super();
		this.lookupType = LookupType.External;
	}
}

export class LookupExtImageModel extends LookupModel
{
	public lookupInternal: LookupInternalModel;
}

export class CurrencyModel
{
	public currencyId: string;
	public code: string;
	public name: string;
	public reference: string;
	public exchangeRate: number;
}

export class CountryModel
{
	public countryId: string;
	public code: string;
	public name: string;
	public isFrequentlyUsed: boolean;
}

export class TaxRatesModel
{
	public baseRate: number;
	public previousRate: number;
}
